// src/pages/admin/components/SectionEditorModal/pickers/FontSelector.jsx
import React from "react";

const FONT_OPTIONS = [
  { value: "Amiri", label: "Amiri (Arabic Classic)" },
  { value: "Assistant", label: "Assistant (Modern Clean)" },
  { value: "Orelega One", label: "Orelega One (Creative)" },
];

export default React.memo(function FontSelector({ value, onChange }) {
  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-gray-700">Font Family</label>

      <div className="grid grid-cols-1 gap-2">
        {FONT_OPTIONS.map((font) => {
          const active = value === font.value;

          return (
            <button
              key={font.value}
              type="button"
              onClick={() => onChange(font.value)}
              style={{ fontFamily: font.value }}
              className={`p-3 text-left rounded-lg border transition-all
                ${active ? "border-blue-500 bg-blue-50" : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"}
              `}
            >
              <div className="font-medium">{font.label}</div>
              <div className="text-sm text-gray-500">Example Preview Text</div>
            </button>
          );
        })}
      </div>
    </div>
  );
});